module.exports = __webpack_public_path__ + "static/media/kun-4.jpeg";